export class CreateFolderRequest {
    parentId: string;
    name: string;
    relativePath: string;

    constructor(name) {
        this.name = name;
    }
}